import { render, staticRenderFns } from "./GetPrize.vue?vue&type=template&id=213c9634&scoped=true&"
import script from "./GetPrize.vue?vue&type=script&lang=js&"
export * from "./GetPrize.vue?vue&type=script&lang=js&"
import style0 from "./GetPrize.vue?vue&type=style&index=0&id=213c9634&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c9634",
  null
  
)

export default component.exports